<ng-container *ngIf="nuggetAlphaFlow$ | async; then nuggetAlpha; else enhancedPublish"> </ng-container>
<ng-template #nuggetAlpha>
  <div class="title" mat-dialog-title>
    <mode-dialog-header>
      <h1 heading>Publish to ThoughtSpot</h1>
    </mode-dialog-header>
  </div>
  <section class="body">
    <p>This makes the data available as a table in ThoughtSpot’s Mode Connection.</p>
    <form class="section email-form" [formGroup]="form">
      <div class="form-field">
        <div class="flex-center">
          <label class="mode-label" for="dataset-name"> Dataset name </label>
          <capra-status-icon
            class="info-icon"
            status="info"
            capraTooltip
            [tooltipContent]="nameNormalizationInfo"
            [tooltipContentIsHtml]="true"
            tooltipPlacement="right"
            tooltipSize="regular"
          ></capra-status-icon>
        </div>
        <input
          data-test="publish-dataset-name-input"
          id="dataset-name"
          class="mode-input"
          [class.mode-input-error]="form.nameErrors"
          formControlName="name"
          type="text"
          capraAutofocus
        />
        <div *ngIf="form.nameErrors as errors">
          <div class="error-msg" *ngFor="let errorKey of form.errorKeys(errors)">
            <span>{{ errors[errorKey] }}</span>
          </div>
        </div>
      </div>
    </form>
  </section>
  <mode-status-banner status="info" show-icon="true" layout="full-width">
    <span
      >After the table is imported into ThoughtSpot, the most recent results will be used automatically. Changes to the
      Dataset’s structure will require manual updates to the table and may break content built on it.</span
    >
  </mode-status-banner>
</ng-template>
<ng-template #enhancedPublish>
  <div class="title" mat-dialog-title>
    <mode-dialog-header>
      <h1 heading>Publish to the Data workspace</h1>
    </mode-dialog-header>
  </div>
  <section class="body">
    <p class="sub-text">
      This imports the dataset as a table into the Data workspace. The table will only be visible to you and admins by
      default.
    </p>
    <form class="section email-form" [formGroup]="form">
      <div class="form-field">
        <div class="flex-center">
          <label class="mode-label" for="dataset-name"> Dataset name </label>
          <capra-status-icon
            class="info-icon"
            status="info"
            capraTooltip
            [tooltipContent]="nameNormalizationInfo"
            [tooltipContentIsHtml]="true"
            tooltipPlacement="right"
            tooltipSize="regular"
          ></capra-status-icon>
        </div>
        <input
          data-test="publish-dataset-name-input"
          id="dataset-name"
          class="mode-input"
          [class.mode-input-error]="form.nameErrors"
          formControlName="name"
          type="text"
          capraAutofocus
        />
        <div *ngIf="form.nameErrors as errors">
          <div class="error-msg" *ngFor="let errorKey of form.errorKeys(errors)">
            <span>{{ errors[errorKey] }}</span>
          </div>
        </div>
      </div>
    </form>
    <div class="dataset-details">
      <p class="mode-label">Dataset details</p>
      <ng-container *ngIf="!publishLocalDatasetEnabled; else publishLocalDatasetTemplate">
        <!-- support reusable datasets -->
        <mode-dataset-metadata
          *ngIf="dataset$ | async as dataset"
          [isSheetDataset]="(isSheetDataset$ | async) ?? false"
          [hasCalcFields]="(hasCalcFields$ | async) ?? false"
          [rowCount]="dataset.result.rowCount ?? 0"
          [columnCount]="dataset.result.metaColumns.length"
          [size]="dataset.result.bytes ?? 0"
          [connection]="(datasourceDisplayName$ | async) ?? ''"
          [collection]="dataset.details?.collection?.name ?? ''"
          [schedules]="(schedules$ | async) ?? ''"
          (addScheduleClick)="openScheduleModal()"
        ></mode-dataset-metadata>
      </ng-container>
    </div>
  </section>
  <mode-status-banner status="warning" show-icon="true" layout="full-width">
    <span
      >The imported table will automatically use the most recent results available. Changes to the dataset’s structure
      will require manual updates to the table and may break content built on it.</span
    >
  </mode-status-banner>
</ng-template>

<div mat-dialog-actions>
  <capra-button
    class="cancel-btn"
    text="Cancel"
    data-test="cancel-feedback"
    variant="secondary"
    color="neutral"
    modeTrackClick
    [trackClickData]="{ location: 'Publish dataset modal', action: 'Publish dataset close CTA' }"
    (clicked)="close()"
  ></capra-button>
  <capra-button
    text="Publish"
    data-test="send-feedback"
    [disabled]="!form.valid"
    modeTrackClick
    [trackClickData]="{ location: 'Publish dataset modal', action: 'Publish dataset CTA' }"
    (clicked)="publishDataset()"
  ></capra-button>
</div>
<!-- support reusable and local datasets -->
<ng-template #publishLocalDatasetTemplate>
  <mode-dataset-metadata
    *ngIf="enhancedDatasetResult$ | async as dataset"
    [isSheetDataset]="(isSheetDataset$ | async) ?? false"
    [isNotebookCell]="(isNotebookCell$ | async) ?? false"
    [hasCalcFields]="(hasCalcFields$ | async) ?? false"
    [rowCount]="dataset.rowCount ?? 0"
    [columnCount]="dataset.metaColumns.length"
    [size]="dataset.bytes ?? 0"
    [connection]="(datasourceDisplayName$ | async) ?? ''"
    [collection]="(dataset$ | async)?.details?.collection?.name ?? 'Personal'"
    [schedules]="(schedules$ | async) ?? ''"
    (addScheduleClick)="openScheduleModal()"
  ></mode-dataset-metadata>
</ng-template>
